import type { QuartersRangeInMonths } from './types';

// startMonth from BE is returned as 1 - 12
// this function will return months as zero index (0 - 11) for ease of use with native JS date functions
export const getQuarterRanges = (startMonth: number): QuartersRangeInMonths => {
	const initialValue: QuartersRangeInMonths = [];

	if (startMonth < 1 || startMonth > 12) return initialValue;
	const quarters = [1, 2, 3, 4];

	// diff bet custom start month and calendar year start month
	const startOffset = startMonth - 2;

	return quarters.reduce((accumulator, currentValue) => {
		let quarterEnd = currentValue * 3 + startOffset;
		let quarterStart = quarterEnd - 2;
		if (quarterEnd > 11) {
			quarterEnd -= 12;
		}
		if (quarterStart > 11) {
			quarterStart -= 12;
		}
		accumulator.push([quarterStart, quarterEnd]);
		return accumulator;
	}, initialValue);
};

export const getQuarterStartOrEndDate = (month: number, start = true): Date => {
	const today = new Date();
	let year: number = today.getFullYear();
	const currentMonth: number = today.getMonth();
	if (month < currentMonth) {
		// if the given month has passed, set the year to next year
		// necessary to achieve the correct Feb end date in a leap year
		year++;
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setDate#description
	// a day of 0 changes the date to the last day of the previous month
	// (so we must also increment the month value in this scenario)
	return new Date(year, start ? month : month + 1, start ? 1 : 0);
};
